<template>
    <div class="controls-wrapper">
        <div @click.prevent="$emit('zoom-in')" class="control">
            <i class="fas fa-search-plus fa-lg"></i>
        </div>
        
        <hr class="spacer" />
        
        <div @click.prevent="$emit('zoom-out')" class="control">
            <i class="fas fa-search-minus fa-lg"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "canvas-area-zoom-controls"
}
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/Shared/colors";
    
    .controls-wrapper {
        //Stack buttons
        display: flex;
        flex-flow: column;
        
        background-color: $white;
        box-shadow: 0 0 3px 1px #BDB6B8;
        border-radius: 5px;

        .control {
            cursor: pointer;
            padding: 7.5px 5px;

            &:first-child {
                border-bottom-left-radius: 2.5px;
                border-bottom-right-radius: 2.5px;
            }
            
            &:last-child {
                border-top-left-radius: 2.5px;
                border-top-right-radius: 2.5px;
            }
            
            &:hover {
                background-color: $light-grey;
            }
        }
        
        .spacer {
            margin-top: 0;
            margin-bottom: 0;
            border-top-width: 2px;
        }
    }
</style>